import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { PriceContext } from './context';
import { list } from 'postcss';

// Styled-components for the main container
const AppContainer = styled.div`
    min-height: 100vh; /* Use vh for full viewport height */
    width: 100%;
    background-color: #f9fafb; /* bg-gray-50 */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1rem; /* Consistent padding using rem */
    font-family: 'Inter', sans-serif; /* font-inter */
    box-sizing: border-box; /* Ensures padding doesn't add to overall width */
`;

// Styled-component for the page title
const Title = styled.h1`
    font-size: 2rem; /* Start with a more reasonable size */
    font-weight: bold;
    color: #2d3748; /* text-gray-800 */
    margin-bottom: 2rem; /* mb-8 */
    border-radius: 0.5rem; /* rounded-lg */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* shadow-md */
    padding: 1rem 1.5rem; /* p-4 with a bit more horizontal padding */
    background-color: #ffffff; /* bg-white */
    text-align: center; /* Center text for better appearance */

    @media (min-width: 640px) { /* sm */
        font-size: 2.5rem; /* Increase for larger screens */
    }
`;

// Styled-component for the grid container
const TeamsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* Default to 2 columns */
    gap: 1rem; /* Smaller gap for tighter fit */
    max-width: 90%; /* Use a percentage for max-width to be more flexible */
    width: 100%; /* Ensure it takes full width within max-width */
    padding: 0 1rem; /* Add horizontal padding to prevent bursting */
    box-sizing: border-box; /* Include padding in the width calculation */

    @media (min-width: 768px) { /* md: 3 columns for medium screens */
        grid-template-columns: repeat(2, 1fr);
        gap: 1.5rem; /* Slightly larger gap for more space */
    }

    @media (min-width: 1024px) { /* lg: 4 columns for large screens */
        grid-template-columns: repeat(2, 1fr);
        gap: 2rem; /* Even larger gap for plenty of space */
    }


`;

// Styled-component for individual team boxes
const TeamBox = styled.div`
    padding: 1rem; /* Adjusted padding to make boxes smaller */
    border-radius: 0.5rem; /* rounded-lg */
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1); /* Slightly softer shadow */
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem; /* Adjusted font size */
    font-weight: 600; /* font-semibold */
    transition: all 0.3s ease-in-out; /* smooth transitions */
    min-height: 80px; /* Give boxes a minimum height to prevent squishing */
    text-align: center; /* Ensure text is centered within the box */

    &:hover {
        transform: scale(1.03); /* subtle scale on hover */
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15); /* deeper shadow on hover */
    }

    ${props => props.$isSelected ? `
        background-color: #2563eb; /* blue-600 */
        color: #ffffff; /* white */
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2); /* deeper shadow when selected */
    ` : `
        background-color: #ffffff; /* white */
        color: #2d3748; /* gray-800 */
    `}
`;

// Styled-component for the selected teams display
const SelectedTeamsDisplay = styled.p`
    margin-top: 2rem; /* mt-8 */
    font-size: 1.1rem; /* Slightly smaller font for display */
    color: #4a5568; /* text-gray-700 */
    padding: 0.75rem 1.5rem; /* p-3 */
    background-color: #ffffff; /* bg-white */
    border-radius: 0.5rem; /* rounded-lg */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* shadow-md */
    text-align: center;
    max-width: 90%; /* Also use percentage for display width */
    width: 100%;
    box-sizing: border-box;
`;

const SelectedTeamsSpan = styled.span`
    font-weight: bold;
    color: #2563eb; /* text-blue-600 */
`;

const SubmitButton = styled.button`
  ${props => (props.disabled) && `
pointer-events: none;
opacity: 0.5;
  `}
  justify-self:center;
  padding: 10px 20px;
  font-size: 16px;
  color: #ffffff;
  background-color: #007bff; /* Bright blue to stand out */
  border: none;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Adds depth */
  transition: background-color 0.3s, box-shadow 0.3s; /* Smooth hover transition */

  &:hover {
    background-color: #0056b3; /* Darker blue on hover */
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2); /* Slightly more prominent shadow on hover */
  }
`;

// Main Teams component
const Teams = ({navigate, teamCount }) => {
  const {setTeams } = useContext(PriceContext);

    // Mens nba
    // const teams = [
    //     'ATL', 'BOS', 'BRK', 'CHI', 'CHO', 'CLE', 'DAL', 'DEN', 'DET', 'GSW',
    //     'HOU', 'IND', 'LAC', 'LAL', 'MEM', 'MIL', 'MIN', 'MIA', 'NOP', 'NYK',
    //     'OKC', 'ORL', 'PHI', 'PHO', 'POR', 'SAC', 'SAS', 'TOR', 'UTA', 'WAS'
    // ];

    //womans wnba
    const teams = ['TOR', 'BOS', 'NYK', 'BRK', 'PHI', 'CLE','IND','DET','CHI','MIL', 'MIA', 'ATL', 'CHO','WAS', 'ORL', 'OKC','POR','UTA','DEN','MIN', 'GSW', 'LAC','SAC','PHO','LAL', 'SAS','DAL','MEM','HOU','NOP']


    const [disabled, setDisabled] = useState(true)
    const [selectedTeamIndices, setSelectedTeamIndices] = useState([]);


    function index_grab(indexes, list_items){
        let team_list = []
       for (let i = 0; i < indexes.length; i++){
            team_list.push(list_items[indexes[i]])
            console.log(team_list)
        
       }
       return team_list
    }


    function handleSubmit(c){
    // Mens NBA 
    //const teams = [;['ATL','BOS','BKN','CHA','CHI','CLE','DAL','DEN','DET','GSW','HOU','IND','LAC','LAL','MEM','MIA','MIL','MIN','NOP','NOH','PHO','NYK', 'NJN','OKC','ORL','PHI','PHX','POR','SAC','SAS','TOR','UTA','WAS']
    //womens wnba 
    const teams = ["ATL","CHI","CON","DAL","GSV","IND","LAS","LVA","MIN","NYL","PHO","POR","SEA","TOR","WAS"]  
    console.log('this is it',selectedTeamIndices)
        const selectedItems = index_grab(selectedTeamIndices, teams)  
        setTeams(selectedItems)
         navigate('/payment')
    }
    const handleBoxClick = (index) => {
        setSelectedTeamIndices(prevIndices => {
            const isSelected = prevIndices.includes(index);
            if(prevIndices.length==teamCount -1){
                setDisabled(false)
            }
           
            if (isSelected) {
                return prevIndices.filter(i => i !== index);
            } else {
                if (prevIndices.length < teamCount) {
                    return [...prevIndices, index];
                } else {
                    return prevIndices;
                }
            }
        });
    };

    return (
        <AppContainer>
            <Title>
                Select Your  {teamCount} Teams 
            </Title>

            <TeamsGrid>
                {teams.map((team, index) => (
                    <TeamBox
                        key={index}
                        $isSelected={selectedTeamIndices.includes(index)}
                        onClick={() => handleBoxClick(index)}
                    >
                        {team}
                    </TeamBox>
                ))}
            </TeamsGrid>

            {selectedTeamIndices.length > 0 && (
                <SelectedTeamsDisplay>
                    Selected Teams: <SelectedTeamsSpan>{selectedTeamIndices.map(i => teams[i]).join(', ')}</SelectedTeamsSpan>
                </SelectedTeamsDisplay>
            )}
            {selectedTeamIndices.length === 0 && (
                 <SelectedTeamsDisplay>
                    No teams selected.
                 </SelectedTeamsDisplay>
            )}
                    <SubmitButton  disabled={disabled}onClick={() => {handleSubmit('c')} }>  Next</SubmitButton>

        </AppContainer>
    );
};

export default Teams;